$(window).scroll(function () {
  var sticky = $('header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.addClass('whiteBackground');
  } else {
    sticky.removeClass('whiteBackground');
  }
});
 document.addEventListener('DOMContentLoaded', function () {

  const videoPlayPause = document.querySelectorAll(".video-play-pause");
  videoPlayPause.forEach(function(control){
    control.addEventListener("click",function(e){
      e.preventDefault();
      e.stopPropagation();
      let video = this.closest(".video-slide").querySelector("video");
      console.log(video);
      if(this.classList.contains("active"))
      {
        video.play();
      }
      else
      {
        video.pause();
      }
      this.classList.toggle('active');
    });
  });

  const videoMute = document.querySelectorAll(".video-sound");
  videoMute.forEach(function(control){
    control.addEventListener("click",function(e){
      e.preventDefault();
      e.stopPropagation();
      let video = this.closest(".video-slide").querySelector("video");
      console.log(video);
      if(this.classList.contains("active"))
      {
        video.muted = true;
      }
      else
      {
        video.muted = false;
      }
      this.classList.toggle('active');
    });
  });
});


// 

document.addEventListener("DOMContentLoaded", function () {
  function initProductSlider() {
    $("[data-slick-slider]").each(function () {
      const $slider = $(this);

      if ($slider.hasClass("slick-initialized")) return;

      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1800,
        speed: 300,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              arrows: false,
              dots: false
            }
          }
        ]
      });
    });
  }

  initProductSlider();

  document.addEventListener("shopify:section:load", function () {
    initProductSlider();
  });
});